export default "__VITE_ASSET__kwaC5Rn7__"